export const LOGIN_PENDING = "LOGIN_PENDING";
export const LOGIN_SUCCESS = "LOGIN_SUCCES";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const REGISTER_PENDING = "REGISTER_PENDING";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const GET_VENDOR_BEGIN = "GET_VENDOR_BEGIN";
export const GET_VENDOR_SUCCESS = "GET_VENDOR_SUCCESS";
export const GET_VENDOR_FAIL = "GET_VENDOR_FAIL";
export const EDIT_VENDOR_BEGIN = "EDIT_VENDOR_BEGIN";
export const EDIT_VENDOR_SUCCESS = "EDIT_VENDOR_SUCCESS";
export const EDIT_VENDOR_FAIL = "EDIT_VENDOR_FAIL";
export const LOGOUT = "LOGOUT";

export const GET_ALL_PACKAGE_BEGIN = "GET_ALL_PACKAGE_BEGIN"
export const GET_ALL_PACKAGE_SUCCESS = "GET_ALL_PACKAGE_SUCCESS"
export const GET_ALL_PACKAGE_FAIL = "GET_ALL_PACKAGE_FAIL"

export const GET_ALL_QUOTATIONS_BEGIN = "GET_ALL_QUOTATIONS_BEGIN"
export const GET_ALL_QUOTATIONS_SUCCESS = "GET_ALL_QUOTATIONS_SUCCESS"
export const GET_ALL_QUOTATIONS_FAIL = "GET_ALL_QUOTATIONS_FAIL"

export const GET_QUOTATIONS_ID_BEGIN = "GET_QUOTATIONS_ID_BEGIN"
export const GET_QUOTATIONS_ID_SUCCESS = "GET_QUOTATIONS_ID_SUCCESS"
export const GET_QUOTATIONS_ID_FAIL = "GET_QUOTATIONS_ID_FAIL"

export const GET_PACKAGE_ID_BEGIN = "GET_PACKAGE_ID_BEGIN"
export const GET_PACKAGE_ID_SUCCESS = "GET_PACKAGE_ID_SUCCESS"
export const GET_PACKAGE_ID_FAIL = "GET_PACKAGE_ID_FAIL"

export const CREATE_PACKAGE_BEGIN = "CREATE_PACKAGE_BEGIN"
export const CREATE_PACKAGE_SUCCESS = "CREATE_PACKAGE_SUCCESS"
export const CREATE_PACKAGE_FAIL = "CREATE_PACKAGE_FAIL"

export const POST_QUOTATIONS_BEGIN = "POST_QUOTATIONS_BEGIN"
export const POST_QUOTATIONS_SUCCESS = "POST_QUOTATIONS_SUCCESS"
export const POST_QUOTATIONS_FAIL = "POST_QUOTATIONS_FAIL"

export const EDIT_PACKAGE_BEGIN = "EDIT_PACKAGE_BEGIN"
export const EDIT_PACKAGE_SUCCESS = "EDIT_PACKAGE_SUCCESS"
export const EDIT_PACKAGE_FAIL = "EDIT_PACKAGE_FAIL"

export const DELETE_PACKAGE_BEGIN = "DELETE_PACKAGE_BEGIN"
export const DELETE_PACKAGE_SUCCESS = "DELETE_PACKAGE_SUCCESS"
export const DELETE_PACKAGE_FAIL = "DELETE_PACKAGE_FAIL"

export const GET_CONFIG_LOCATION_BEGIN = "GET_CONFIG_LOCATION_BEGIN"
export const GET_CONFIG_LOCATION_SUCCESS = "GET_CONFIG_LOCATION_SUCCESS"
export const GET_CONFIG_LOCATION_FAIL = "GET_CONFIG_LOCATION_FAIL"
export const GET_CONFIG_VENUE_BEGIN = "GET_CONFIG_VENUE_BEGIN"
export const GET_CONFIG_VENUE_SUCCESS = "GET_CONFIG_VENUE_SUCCESS"
export const GET_CONFIG_VENUE_FAIL = "GET_CONFIG_VENUE_FAIL"
export const GET_CONFIG_ORGANIZER_BEGIN = "GET_CONFIG_ORGANIZER_BEGIN"
export const GET_CONFIG_ORGANIZER_SUCCESS = "GET_CONFIG_ORGANIZER_SUCCESS"
export const GET_CONFIG_ORGANIZER_FAIL = "GET_CONFIG_ORGANIZER_FAIL"